import { render, staticRenderFns } from "./modal-historico.vue?vue&type=template&id=01462c48"
import script from "./modal-historico.vue?vue&type=script&lang=js"
export * from "./modal-historico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports